import { render, staticRenderFns } from "./assumptions.vue?vue&type=template&id=6f7d87ae&scoped=true&"
import script from "./assumptions.vue?vue&type=script&lang=js&"
export * from "./assumptions.vue?vue&type=script&lang=js&"
import style0 from "./assumptions.vue?vue&type=style&index=0&id=6f7d87ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7d87ae",
  null
  
)

export default component.exports